const
    PROJECT = 'cost_center',
    ACCOUNT = 'account',
    VENDOR = 'vendor',
    SERVICE = 'product',
    REGION = 'region';

export const CLOUD_BILLING_ENTITY_TYPE = {
    PROJECT,
    ACCOUNT,
    VENDOR,
    SERVICE,
    REGION
};

export const CLOUD_BILLING_ENTITY_TYPE_LIST = [
    ACCOUNT,
    PROJECT,
    VENDOR,
    SERVICE,
    REGION
];

const
    INCLUDE = 0,
    EXCLUDE = 1;

export const CLOUD_BILLING_TYPE_REQUEST = {
    INCLUDE,
    EXCLUDE
};


const
    BTN_SELECT_ALL = 'btn_select_all',
    BTN_SELECT_PAGE = 'btn_select_page',
    BTN_SELECT_NONE = 'btn_select_none',
    BTN_SHOW_SELECTION = 'btn_show_selection',
    BTN_BREAKDOWN = 'btn_breakdown',
    BTN_FAV = 'btn_fav';

export const CLOUD_BILLING_ENTITIES_TABLE_ACTION_BUTTONS = {
    BTN_SELECT_ALL,
    BTN_SELECT_PAGE,
    BTN_SELECT_NONE,
    BTN_SHOW_SELECTION,
    BTN_BREAKDOWN,
    BTN_FAV
};


export const BTN_BREAKDOWN_ALLOWED_ENTITY_TYPES = [
    CLOUD_BILLING_ENTITY_TYPE.ACCOUNT,
    CLOUD_BILLING_ENTITY_TYPE.PROJECT,
    CLOUD_BILLING_ENTITY_TYPE.VENDOR
];



// WEBPACK FOOTER //
// ./src/containers/cloud-billing/utils/constants.js